// Catálogo SUNAT de motivos de Nota de Crédito/Débito (Perú). Completo, sin
// restringir a un subconjunto -- a validar contra el catálogo real de BC.
export const MOTIVOS_NOTA_CREDITO_PERU = [
  { value: "01", label: "Anulación de la operación" },
  { value: "02", label: "Anulación por error en el RUC" },
  { value: "03", label: "Corrección por error en la descripción" },
  { value: "04", label: "Descuento global" },
  { value: "05", label: "Descuento por ítem" },
  { value: "06", label: "Devolución total" },
  { value: "07", label: "Devolución por ítem" },
  { value: "08", label: "Bonificación" },
  { value: "09", label: "Disminución en el valor" },
  { value: "10", label: "Otros conceptos" },
  { value: "11", label: "Ajustes de operaciones de exportación" },
  { value: "12", label: "Ajustes afectos al IVAP" },
  { value: "13", label: "Corrección de monto pendiente / fechas de pago" },
];

// Lo que admite el campo «Sustento» de la nota de crédito en Business Central
// (Text[50]). El formulario lo limita y el envío lo recorta: un sustento más
// largo dejaba la nota de crédito en el terminal sin cabecera en BC. Medido en
// PER TEST el 29/10/2026 con uno de 55 caracteres.
export const LARGO_DEL_SUSTENTO_NC = 50;

/** El sustento como lo acepta BC: sin espacios sobrantes y con 50 como máximo. */
export const sustentoParaBC = (texto) =>
  String(texto ?? "").trim().slice(0, LARGO_DEL_SUSTENTO_NC);
